var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"tc-closeable-message"},[_c('span',[_vm._v(_vm._s(_vm.content))]),_c('x-icon',{attrs:{"type":"close"},on:{"click":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }